import { useEffect, useState } from "react";
import { AlertTriangle, Trash2 } from "lucide-react";
import { toast } from "sonner";
import api from "../lib/api";
import { fmtDate } from "../lib/format";

// Záznamy odkazující na smazanou (neexistující) zakázku – jen vlastník/admin, zobrazí se jen když nějaké jsou.
export function OrphanRecordsPanel({ onChanged }) {
    const [d, setD] = useState(null);
    const [busy, setBusy] = useState(null);
    const load = () => api.get("/jobs/orphans/list").then((r) => setD(r.data)).catch(() => setD({ groups: [], total: 0 }));
    useEffect(() => { load(); }, []);
    if (!d || !d.groups.length) return null;
    const del = async (g) => {
        const lines = g.records.map((r) => `${r.label}: ${r.count}`).join("\n");
        if (!window.confirm(`Smazat osiřelé záznamy „${g.title || g.job_id}“?\n\n${lines}\n\nTuto akci nelze vrátit.`)) return;
        setBusy(g.job_id);
        try { const { data } = await api.delete(`/jobs/orphans/${g.job_id}`); toast.success(`Smazáno: ${Object.entries(data.deleted).map(([k, v]) => `${k} ${v}`).join(", ") || "0"}${Object.keys(data.unlinked).length ? ` · odpojeno: ${Object.entries(data.unlinked).map(([k, v]) => `${k} ${v}`).join(", ")}` : ""}`); await load(); onChanged?.(); }
        catch (e) { toast.error(e.response?.data?.detail || "Smazání selhalo"); }
        finally { setBusy(null); }
    };
    return (
        <div className="border-2 border-amber-500 bg-amber-50 mb-8" data-testid="orphan-records-panel">
            <div className="px-4 py-3 flex items-start gap-3">
                <AlertTriangle className="w-5 h-5 text-amber-700 shrink-0 mt-0.5" />
                <div className="flex-1 min-w-0">
                    <div className="font-display font-bold text-sm uppercase tracking-wider text-amber-900">Osiřelé záznamy po smazaných zakázkách ({d.total})</div>
                    <p className="text-xs text-amber-900/80 mt-0.5">Tyto záznamy odkazují na zakázku, která už neexistuje. Nepočítají se do přehledů – smažte je, nebo je přiřaďte jiné zakázce ručně.</p>
                    <div className="mt-3 space-y-2">
                        {d.groups.map((g) => (
                            <div key={g.job_id} className="bg-white border border-amber-200 px-3 py-2 flex items-center gap-3 flex-wrap" data-testid={`orphan-group-${g.job_id}`}>
                                <div className="flex-1 min-w-0">
                                    <div className="font-semibold text-sm text-slate-900">{g.title || "(zakázka bez názvu)"} <span className="text-xs text-slate-400 font-normal">· {g.job_id.slice(0, 8)}…{g.last_date ? ` · poslední ${fmtDate(g.last_date)}` : ""}</span></div>
                                    <div className="text-xs text-slate-600">{g.records.map((r) => `${r.label}: ${r.count}`).join(" · ")}</div>
                                </div>
                                <button onClick={() => del(g)} disabled={busy === g.job_id} data-testid={`orphan-delete-${g.job_id}`} className="inline-flex items-center gap-1.5 px-3 py-2 text-xs uppercase tracking-wider font-semibold bg-red-700 hover:bg-red-800 text-white rounded-sm disabled:opacity-50"><Trash2 className="w-3.5 h-3.5" /> Smazat záznamy</button>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}
